// ChatApp.tsx
import React, { useState } from 'react';
import { Container, Row, Col, ListGroup, Nav } from 'react-bootstrap';

// Mock data
interface ChatPreview {
  id: number;
  name: string;
  lastMessage: string;
  time: string;
  unread?: number;
}

const chatList: ChatPreview[] = [
  {
    id: 1,
    name: 'Justin',
    lastMessage: 'Appreciate the business...',
    time: '2:45 PM',
  },
  {
    id: 2,
    name: 'Sarah',
    lastMessage: 'See you tomorrow!',
    time: '11:20 AM',
    unread: 2,
  },
  {
    id: 3,
    name: 'David',
    lastMessage: 'Thanks for the update',
    time: 'Yesterday',
  },
];

const ChatApp: React.FC = () => {
  const [activeChat, setActiveChat] = useState<ChatPreview | null>(chatList[0]);

  return (
    <Container fluid className="p-0" style={{ height: '100vh', background: '#fff' }}>
      <Row className="g-0" style={{ height: '100%' }}>
        {/* Sidebar */}
        <Col md={3} className="border-end" style={{ backgroundColor: '#f8f9fa' }}>
          <div
            className="d-flex align-items-center p-3"
            style={{ backgroundColor: '#0f5132', color: 'white' }}
          >
            <span className="me-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
              ✔
            </span>
            <h5 className="mb-0">SkipScreen</h5>
          </div>

          <Nav fill variant="tabs" defaultActiveKey="messages">
            <Nav.Item>
              <Nav.Link eventKey="questions">Questions</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="messages">Messages</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="contacts">Contacts</Nav.Link>
            </Nav.Item>
          </Nav>

          <ListGroup variant="flush">
            {chatList.map((chat) => (
              <ListGroup.Item
                key={chat.id}
                action
                onClick={() => setActiveChat(chat)}
                active={activeChat?.id === chat.id}
                className="d-flex justify-content-between align-items-center"
              >
                <div>
                  <div className="fw-bold">{chat.name}</div>
                  <small className="text-muted">{chat.lastMessage}</small>
                </div>
                <div className="text-end">
                  <small className="text-muted">{chat.time}</small>
                  {chat.unread && <span className="badge bg-success ms-2">{chat.unread}</span>}
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>

        {/* Chat Window */}
        <Col md={9}>
          {activeChat ? (
            <div
              style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* Chat Header */}
              <div className="border-bottom p-3 d-flex align-items-center">
                <h6 className="mb-0">{activeChat.name}</h6>
              </div>

              {/* Chat Messages */}
              <div
                style={{
                  flex: 1,
                  overflowY: 'auto',
                  padding: '1rem',
                  background: '#fff',
                }}
              >
                {/* Example messages */}
                <div className="p-2 mb-2 rounded bg-light" style={{ maxWidth: '75%' }}>
                  Hello, the other job I had took longer but I’ll be at yours soon
                </div>

                <div className="d-flex justify-content-end">
                  <div
                    className="p-2 mb-2 rounded"
                    style={{ backgroundColor: '#e9f7ef', maxWidth: '75%' }}
                  >
                    No worries
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <p className="text-muted">Select a chat to start messaging</p>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ChatApp;
